// extracted by mini-css-extract-plugin
module.exports = {"requestsContainer":"UserActiveRequests_requestsContainer__20M_D","noRequests":"UserActiveRequests_noRequests__32iNb","pageNav":"UserActiveRequests_pageNav__26Liw"};